import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { showModal } from 'Core/redux/main/slice';
import { deleteInventory, quarantineInventory, releaseInventory } from './store/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { Filter, Sliders } from 'feather-icons-react/build/IconComponents';
import { ImageWithBasePath } from 'Core/components';
import Select from 'react-select';
import { actions as inventoryActions } from './store/slice';
import { selectInventoryFilterVisible } from './store/selectors';
const { INVENTORY_ADD_EDIT } = MODAL_TYPES;

const initData = {
  id: 0,
  assetNumber: '',
  downloadedFile: '',
  inventoryDate: '',
  inventoryScan: '',
  inventoryScanDate: '',
  iqmsInventoryDate: '',
  locationName: '',
  partNumber: '',
  scanUserName: '',
  serialNumber: '',
  shipmentASP: '',
  userId: '',
  userName: '',
  isQuarantine: '',
};

const { setFilterVisible, setSearchText } = inventoryActions;
const InventorySerialNumberTable = ({ data, onChanges, pagination, onPageChange }) => {
  const [partInputs, setPartInputs] = useState(initData);
  const [parts, setParts] = useState(data);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchTextValue] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    setParts(data)
    setSelectedRows([]);
  }, [data]);

  useEffect(() => {
    if (onChanges) onChanges(parts);
  }, [parts, onChanges]);

  const handleBulkAction = async action => {
    if (selectedRows.length === 0) {
      alert('Please select atlease one item');
      return;
    }

    // Check for already quarantined/released items
    if (action === 'quarantine') {
      const alreadyQuarantined = selectedRows.filter(row => row.isQuarantine === 'Y');
      if (alreadyQuarantined.length > 0) {
        alert(`Invalid selection: ${alreadyQuarantined.length} item(s) are already quarantined.\nPlease review your selection.`);
        return;
      }
    } else if (action === 'release') {
      const notQuarantined = selectedRows.filter(row => row.isQuarantine !== 'Y');
      if (notQuarantined.length > 0) {
        alert(`Invalid selection: ${notQuarantined.length} item(s) are not in quarantine.\nPlease review your selection.`);
        return;
      }
    }
    
    setIsLoading(true);
    const actionFunction = action === 'quarantine' ? quarantineInventory : releaseInventory;

    try {
      const payload = {
        userId: localStorage.getItem('UserId'),
        parts: selectedRows.map(record => ({
          partId: record.partId,
          serialNumber: record.serialNumber,
        })),
      };

      // Make a single API call with all records
      await dispatch(actionFunction(payload));

      // Update the local state
      const updatedParts = parts.map(part => {
        if (selectedRows.some(selected => selected.serialNumber === part.serialNumber)) {
          return { ...part, isQuarantine: action === 'quarantine' ? 'Y' : 'N' };
        }
        return part;
      });

      setParts(updatedParts);
      setSelectedRows([]); // Clear selection after action
    } catch (error) {
      console.error('Error processing bulk action:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSearch = e => {
    const newSearchText = e.target.value;
    setSearchTextValue(newSearchText);
    //parts.filters.searchText=newSearchText;
    dispatch(setSearchText(newSearchText));
  };
  // Row selection configuration
  const rowSelection = {
    selectedRowKeys: selectedRows.map(row => row.serialNumber),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRows(selectedRows);
    },
  };
  const oldandlatestvalue = [
    { value: 'date', label: 'Sort by Date' },
    { value: 'newest', label: 'Newest' },
    { value: 'oldest', label: 'Oldest' },
  ];
  const columns = [
    {
      title: 'Serial Number',
      dataIndex: 'serialNumber',
      sorter: (a, b) => a.serialNumber?.length - b.serialNumber?.length,
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      sorter: (a, b) => parseInt(a.quantity) - parseInt(b.quantity),
    },
    {
      title: 'Inventory Date',
      dataIndex: 'inventoryDate',
      sorter: (a, b) => a.inventoryDate?.length - b.inventoryDate?.length,
    },
    {
      title: 'Inventory Scan',
      dataIndex: 'inventoryScan',
      sorter: (a, b) => a.inventoryScan?.length - b.inventoryScan?.length,
    },
    {
      title: 'Scan Date',
      dataIndex: 'inventoryScanDate',
      sorter: (a, b) => a.inventoryScanDate?.length - b.inventoryScanDate?.length,
    },
    {
      title: 'IQMS Inventory',
      dataIndex: 'iqmsInventory',
      sorter: (a, b) => a.iqmsInventory?.length - b.iqmsInventory?.length,
    },
    {
      title: 'Pallet',
      dataIndex: 'pallet',
      sorter: (a, b) => a.pallet?.length - b.pallet?.length,
    },
    {
      title: 'Quarantine',
      dataIndex: 'isQuarantine',
      sorter: (a, b) => a.isQuarantine?.length - b.isQuarantine?.length,
    },
    {
      title: 'Update On Hand',
      dataIndex: 'updateOnHand',
      sorter: (a, b) => a.updateOnHand?.length - b.updateOnHand?.length,
    },
    {
      title: 'Created By',
      dataIndex: 'createdBy',
      sorter: (a, b) => a.createdBy?.length - b.createdBy?.length,
    },
    {
      title: 'Scanned By',
      dataIndex: 'scannedBy',
      sorter: (a, b) => a.scannedBy?.length - b.scannedBy?.length,
    },
  ];

  return (
    <div>
      <div className="mb-3 ms-4 mt-3">
        <button className="btn btn-warning me-2" onClick={() => handleBulkAction('quarantine')}>
          Quarantine Selected
        </button>
        <button className="btn btn-info me-2" onClick={() => handleBulkAction('release')}>
          Release Selected
        </button>
        {selectedRows.length > 0 && (
          <span className="ms-2">{selectedRows.length} items selected</span>
        )}
      </div>

      <div className="table-responsive product-list">
        {isLoading && <LoadingSpinner />}
        <Table
          rowSelection={rowSelection}
          rowKey="serialNumber"
          columns={columns}
          dataSource={[...parts]}
          pagination={
            pagination
              ? {
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  total: pagination.total,
                  showSizeChanger: false,
                }
              : undefined
          }
          onChange={(tablePagination) => {
            if (!onPageChange || !pagination) return;
            if (!tablePagination) return;
            const nextPage = tablePagination.current || 1;
            const nextPageSize = tablePagination.pageSize || pagination.pageSize || 10;
            onPageChange(nextPage, nextPageSize);
          }}
        />
      </div>
    </div>
  );
};

export default InventorySerialNumberTable;
